var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCompany48Line = function SvgIconCompany48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 20.3h-2.7v-5.7a5.3 5.3 0 0 0-5.3-5.3H14.6a5.3 5.3 0 0 0-5.3 5.3v18.8a5.31 5.31 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3v-7.8a5.3 5.3 0 0 0-5.3-5.3ZM12.7 33.4V14.6a1.9 1.9 0 0 1 1.9-1.9h10.8a1.9 1.9 0 0 1 1.9 1.9v20.7h-5.6V30h-3.4v5.3h-3.7a1.9 1.9 0 0 1-1.9-1.9Zm22.6 0a1.9 1.9 0 0 1-1.9 1.9h-2.7V23.7h2.7a1.9 1.9 0 0 1 1.9 1.9v7.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.8h-7v3.4h7v-3.4ZM23.5 22.3h-7v3.4h7v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconCompany48Line;